import styled from 'styled-components';

const AskAnotherQuestion = styled.p`
  text-align: center;
  cursor: pointer;
  margin-bottom: 0;
`;

export default AskAnotherQuestion;
